import './polyfills/element-matches';
import 'cleave.js';

import HomeSearch from './home-search';
import { OpportunitySearch } from './search/OpportunitySearch';

if (window.location.pathname === '/search') {
  require('./algolia');
}

if (window.location.pathname === '/') {
  new HomeSearch().init();
}

window.AFG = {
  OpportunitySearch,
};
